module.exports = __webpack_public_path__ + "assets/img/social/telegram-icon.707e9d34e6a90072a7a440a724997556.svg";